/* GlowyCase 3D viewer v2 — glow-in-the-dark liquid AirPods Pro 2 case. Core three.js r169 from CDN; everything else is here. */
(function () {
'use strict';
var THREE_URL = 'https://cdn.jsdelivr.net/npm/three@0.169.0/build/three.module.min.js';

var CSS = ".gc,.gc *{box-sizing:border-box}.gc{color:#2b2433;font-family:inherit;max-width:560px!important;margin:0 auto;padding:28px 16px 36px}.gc .eyebrow{font-size:11px;letter-spacing:2.2px;text-transform:uppercase;opacity:.65}.gc h2{font-size:30px;letter-spacing:-.8px;margin:6px 0 4px;line-height:1.1}.gc p{font-size:14px;line-height:1.5;margin:6px 0}.gc .gc-stage{position:relative;border-radius:22px;overflow:hidden;margin:18px 0 14px;background:#ece7e1;aspect-ratio:1/1;max-height:560px;width:100%;transition:background .6s}.gc .gc-stage.night{background:#050509}.gc .gc-stage canvas{display:block;width:100%!important;height:100%!important;touch-action:none;cursor:grab;outline:none}.gc .gc-stage canvas:active{cursor:grabbing}.gc .gc-stage canvas:focus-visible{box-shadow:inset 0 0 0 3px #b9a2e8}.gc .gc-help{position:absolute;left:0;right:0;bottom:14px;text-align:center;pointer-events:none;font-size:12px;color:#7a7180}.gc .gc-stage.night .gc-help{color:#8e88a0}.gc .gc-fallback{position:absolute;left:0;right:0;top:45%;text-align:center}.gc .gc-swatches{display:flex;gap:7px;justify-content:center;flex-wrap:wrap}.gc button{font:inherit;cursor:pointer;min-height:44px;border:1px solid #d9d1df;color:#2b2433;background:#fff;border-radius:14px;padding:10px 14px}.gc .gc-swatch{display:flex;align-items:center;gap:7px;font-size:13px;padding:8px 12px}.gc .gc-swatch i{width:18px;height:18px;border-radius:50%;background:var(--swatch);box-shadow:inset 0 0 0 1px #0002,inset 0 4px 6px #fff6}.gc button[aria-pressed=true]{border-color:#6f5596;box-shadow:0 0 0 1px #6f5596}.gc .gc-actions{display:flex;gap:8px;margin:14px 0 6px;flex-wrap:wrap}.gc .gc-actions button{flex:1 1 40%}.gc .gc-actions .gc-light{background:#2b2433;color:#fff;border-color:#2b2433}.gc .gc-actions .gc-light[aria-pressed=true]{background:#fff;color:#2b2433}.gc .gc-status{text-align:center;min-height:20px;font-size:13px;opacity:.75}.gc .gc-note{color:#81798a;font-size:11px;text-align:center}.gc button:focus-visible{outline:3px solid #b9a2e8;outline-offset:3px}@media(max-width:420px){.gc h2{font-size:26px}.gc .gc-actions button{font-size:13px;padding:10px 8px}}";

var MARKUP = '<div class="eyebrow">See it before it\'s yours</div><h2>Shake it. Watch it glow.</h2><p>Tap to open it, drag to spin, flick to slosh the glitter, then hit lights off.</p>' +
  '<div class="gc-stage"><canvas tabindex="0" aria-label="3D GlowyCase. Tap or press O to open, drag or arrow keys to rotate, Enter to shake."></canvas><div class="gc-help">Tap to open · Drag to spin · Flick to shake</div></div>' +
  '<div class="gc-swatches" aria-label="Case colour"></div>' +
  '<div class="gc-actions"><button class="gc-open" type="button" aria-pressed="false">Open the case</button><button class="gc-light" type="button" aria-pressed="false">Lights off</button><button class="gc-shake" type="button">Shake it</button><button class="gc-motion" type="button" aria-pressed="false" hidden>Phone motion on</button></div>' +
  '<div class="gc-status" aria-live="polite"></div><p class="gc-note">3D preview · glow strength varies with how long the case charges in light. Cover only, AirPods not included.</p>';

// AirPods Pro 2 case proportions (1 unit ≈ 46 mm)
var W = 1.30, H = 1.0, D = 0.50, R = 0.235, WALL = 0.01, SEAM_Y = 0.21, CY = 0.66;

var VARIANTS = {
  blue:   { label: 'Blue',   swatch: '#1f6f9c', liquid: '#0a6aa6', glitter: '#22414d', glow: '#2f6bff', shell: '#bfe3f5', amt: 1.0 },
  white:  { label: 'White',  swatch: '#e9efd6', liquid: '#232a31', glitter: '#eef2d2', glow: '#35d6ff', shell: '#cfd6dc', amt: 0.9 },
  pink:   { label: 'Pink',   swatch: '#d0307a', liquid: '#d3196c', glitter: '#3a1b2a', glow: '#9a55ff', shell: '#f6c3dc', amt: 1.0 },
  red:    { label: 'Red',    swatch: '#d8261c', liquid: '#e3140b', glitter: '#4b130e', glow: '#ff4b1f', shell: '#f7c0bb', amt: 1.0 },
  green:  { label: 'Green',  swatch: '#1ea52a', liquid: '#10b11b', glitter: '#18361a', glow: '#3dff64', shell: '#c5efc8', amt: 1.0 },
  orange: { label: 'Orange', swatch: '#e9781f', liquid: '#f1680a', glitter: '#3d2510', glow: '#ffae36', shell: '#fad7b7', amt: 1.0 }
};

var VOL_VERT = 'varying vec3 vLocal;\nvoid main(){ vLocal = position; gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0); }';

var VOL_FRAG = [
'precision highp float;',
'varying vec3 vLocal;',
'uniform vec3 uCam, uHalf, uDown, uUp, uFlow, uLiquid, uGlitter, uGlowCol, uBg, uBubble, uDownL, uUpL, uBubbleL, uHinge, uBMin, uBMax;',
'uniform float uR, uStir, uTime, uGlow, uLevel, uAmt, uBubbleR, uBubbleRL, uLiquidK, uSeam, uAng, uSwirl, uSwirl2, uTw;',
'float sdRB(vec3 p){ vec3 q = abs(p) - uHalf + uR; return length(max(q,0.0)) + min(max(q.x,max(q.y,q.z)),0.0) - uR; }',
'float hash13(vec3 p){ p = fract(p*0.1031); p += dot(p, p.zyx + 31.32); return fract((p.x+p.y)*p.z); }',
'vec3 hash33(vec3 p){ p = fract(p*vec3(.1031,.1030,.0973)); p += dot(p, p.yxz+33.33); return fract((p.xxy+p.yxx)*p.zyx); }',
'float vnoise(vec3 x){',
'  vec3 i = floor(x), f = fract(x); f = f*f*(3.0-2.0*f);',
'  return mix(mix(mix(hash13(i),hash13(i+vec3(1,0,0)),f.x), mix(hash13(i+vec3(0,1,0)),hash13(i+vec3(1,1,0)),f.x),f.y),',
'             mix(mix(hash13(i+vec3(0,0,1)),hash13(i+vec3(1,0,1)),f.x), mix(hash13(i+vec3(0,1,1)),hash13(i+vec3(1,1,1)),f.x),f.y), f.z);',
'}',
'float fbm3(vec3 p){ float s=0.0, a=0.5; for(int i=0;i<3;i++){ s += a*vnoise(p); p = p*2.07 + vec3(3.1,1.7,5.3); a *= 0.5; } return s/0.875; }',
'vec3 swirl(vec3 p){',
'  float r2 = dot(p.xz, p.xz), a = uSwirl * exp(-r2*1.1);',
'  float c = cos(a), s = sin(a); p.xz = mat2(c, -s, s, c) * p.xz;',
'  float r3 = dot(p.xy, p.xy), b = uSwirl2 * exp(-r3*1.3);',
'  c = cos(b); s = sin(b); p.xy = mat2(c, -s, s, c) * p.xy;',
'  return p;',
'}',
'float density(vec3 p, vec3 dn){',
'  vec3 q = p*3.2 + uFlow;',
'  vec3 w = vec3(vnoise(q*0.75 + uFlow.zxy*0.35), vnoise(q*0.75 + vec3(5.2,1.3,2.8)), vnoise(q*0.75 + vec3(2.1,7.7,4.4) - uFlow.yzx*0.25));',
'  float n = fbm3(q + (w - 0.5)*3.4);',
'  float h = dot(p, -dn);',
'  float settled = smoothstep(uLevel + 0.26, uLevel - 0.20, h);',
'  float spread = mix(settled, 0.8, uStir);',
'  float silt = 0.10 * smoothstep(uLevel + 0.4, uLevel - 0.3, h) * (1.0 - uStir*0.5);',
'  return (smoothstep(0.40, 0.74, n) * spread + silt) * uAmt;',
'}',
'void main(){',
'  vec3 ro = uCam, rd = normalize(vLocal - uCam);',
'  vec3 inv = 1.0/rd, t0 = (uBMin - ro)*inv, t1 = (uBMax - ro)*inv;',
'  vec3 tmn = min(t0,t1), tmx = max(t0,t1);',
'  float tn = max(max(tmn.x,tmn.y), max(tmn.z,0.0)), tf = min(min(tmx.x,tmx.y), tmx.z);',
'  if (tf <= tn) discard;',
'  const int STEPS = 52;',
'  float ca = cos(uAng), sa = sin(uAng);',
'  float dt = (tf - tn)/float(STEPS);',
'  float jit = hash13(vec3(gl_FragCoord.xy, 3.7));',
'  vec3 T = vec3(1.0), S = vec3(0.0);',
'  vec3 sigL = uLiquidK * -log(max(uLiquid, vec3(0.002))) * (1.0 - 0.35*uGlow);',
'  float wasBubble = 0.0;',
'  for (int i=0; i<STEPS; i++){',
'    vec3 p = ro + rd*(tn + (float(i)+jit)*dt);',
'    vec3 q = p, dn = uDown, upv = uUp, bub = uBubble; float bR = uBubbleR;',
'    if (p.y > uSeam || sdRB(p) > 0.0) {',
'      vec3 dd = p - uHinge; q = uHinge + vec3(dd.x, ca*dd.y - sa*dd.z, sa*dd.y + ca*dd.z);',
'      if (q.y <= uSeam || sdRB(q) > 0.0) { wasBubble = 0.0; continue; }',
'      dn = uDownL; upv = uUpL; bub = uBubbleL; bR = uBubbleRL;',
'    }',
'    float bd = length(q - bub) - bR;',
'    if (bd < 0.0){',
'      if (wasBubble < 0.5) S += T * mix(vec3(0.16), uGlowCol*0.08, uGlow);',
'      T *= exp(-sigL*dt*0.5);',
'      wasBubble = 1.0; continue;',
'    }',
'    wasBubble = 0.0;',
'    vec3 qs = swirl(q);',
'    float d = density(qs, dn);',
'    float hUp = clamp(dot(q, upv)*1.15 + 0.55, 0.0, 1.0);',
'    vec3 lit = mix(vec3(1.0), vec3(0.03), uGlow) * (0.32 + 0.68*hUp);',
'    float sigG = d*24.0;',
'    vec3 ext = sigL + vec3(sigG) + 1e-3;',
'    vec3 src = uGlitter*sigG*lit + uLiquid*0.45*lit*(1.0 - uGlow) + uGlowCol*(d*24.0 + 0.012)*uGlow;',
'    vec3 fq = (qs*3.2 + uFlow*1.35)*30.0, c = floor(fq), f = fract(fq);',
'    float r = hash13(c);',
'    if (r > 0.9 && d > 0.04){',
'      vec3 sp = hash33(c)*0.6 + 0.2;',
'      float tw = pow(0.5 + 0.5*sin(uTw + r*80.0 + dot(rd, vec3(9.0,4.0,6.0))*14.0), 14.0);',
'      vec3 sc = mix(vec3(1.0,0.96,0.88)*1.4, uGlowCol*2.2, uGlow);',
'      S += T*sc*smoothstep(0.38, 0.0, length(f - sp))*tw*min(d*3.0, 1.0);',
'    }',
'    vec3 a = exp(-ext*dt);',
'    S += T*src*(1.0 - a)/ext;',
'    T *= a;',
'    if (max(T.r, max(T.g, T.b)) < 0.008) break;',
'  }',
'  float Ta = (T.r + T.g + T.b)/3.0;',
'  gl_FragColor = vec4(S + uBg*(T - Ta), 1.0 - Ta);',
'}'].join('\n');

var QUAD_VERT = 'varying vec2 vUv; void main(){ vUv = uv; gl_Position = vec4(position.xy, 0.0, 1.0); }';
var BRIGHT_FRAG = 'uniform sampler2D tSrc; uniform float uThr; varying vec2 vUv; void main(){ vec3 c = texture2D(tSrc, vUv).rgb; float l = dot(c, vec3(0.2126,0.7152,0.0722)); gl_FragColor = vec4(c * smoothstep(uThr, uThr + 0.35, l), 1.0); }';
var BLUR_FRAG = 'uniform sampler2D tSrc; uniform vec2 uDir; varying vec2 vUv; void main(){ vec3 c = texture2D(tSrc, vUv).rgb * 0.227027;' +
  ' c += texture2D(tSrc, vUv + uDir*1.3846).rgb*0.316216 + texture2D(tSrc, vUv - uDir*1.3846).rgb*0.316216;' +
  ' c += texture2D(tSrc, vUv + uDir*3.2308).rgb*0.070270 + texture2D(tSrc, vUv - uDir*3.2308).rgb*0.070270; gl_FragColor = vec4(c, 1.0); }';
var COMP_FRAG = 'uniform sampler2D tScene, tB1, tB2; uniform float uStr; varying vec2 vUv;' +
  ' void main(){ vec3 c = texture2D(tScene, vUv).rgb + uStr * (texture2D(tB1, vUv).rgb * 0.7 + texture2D(tB2, vUv).rgb * 1.1); gl_FragColor = vec4(c, 1.0);\n#include <tonemapping_fragment>\n#include <colorspace_fragment>\n}';

function run(THREE) {
  var V3 = THREE.Vector3;
  var lin = function (hex) { return new THREE.Color(hex); };

  // Rounded box with edge-weighted tessellation and exact normals
  function roundedBox(w, h, d, r, sx, sy, sz) {
    var g = new THREE.BoxGeometry(w, h, d, sx, sy, sz);
    var p = g.attributes.position, n = g.attributes.normal;
    var hx = w / 2, hy = h / 2, hz = d / 2, v = new V3(), inner = new V3(), dir = new V3();
    var warp = function (x, hh) { var u = x / hh; return Math.sign(u) * Math.pow(Math.abs(u), 0.55) * hh; };
    for (var i = 0; i < p.count; i++) {
      v.set(warp(p.getX(i), hx), warp(p.getY(i), hy), warp(p.getZ(i), hz));
      inner.set(THREE.MathUtils.clamp(v.x, -hx + r, hx - r), THREE.MathUtils.clamp(v.y, -hy + r, hy - r), THREE.MathUtils.clamp(v.z, -hz + r, hz - r));
      dir.copy(v).sub(inner);
      var L = dir.length();
      if (L > 1e-6) { dir.divideScalar(L); v.copy(inner).addScaledVector(dir, r); n.setXYZ(i, dir.x, dir.y, dir.z); }
      p.setXYZ(i, v.x, v.y, v.z);
    }
    return g;
  }

  // Soft studio environment (light box + softboxes) for realistic reflections
  function makeEnv(renderer) {
    var s = new THREE.Scene();
    var room = new THREE.Mesh(new THREE.BoxGeometry(12, 8, 12), new THREE.MeshBasicMaterial({ color: new THREE.Color(0.42, 0.40, 0.38), side: THREE.BackSide }));
    room.position.y = 2; s.add(room);
    var floor = new THREE.Mesh(new THREE.PlaneGeometry(12, 12), new THREE.MeshBasicMaterial({ color: new THREE.Color(0.75, 0.72, 0.68) }));
    floor.rotation.x = -Math.PI / 2; floor.position.y = -1.9; s.add(floor);
    var panel = function (w, h, x, y, z, ry, rx, k) {
      var m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color: new THREE.Color(k, k, k * 0.96), side: THREE.DoubleSide }));
      m.position.set(x, y, z); m.rotation.set(rx, ry, 0); s.add(m);
    };
    panel(5, 3.5, -1, 5.9, 0.5, 0, Math.PI / 2, 5.5);     // overhead softbox
    panel(2.2, 4, -5.9, 2, 1.5, Math.PI / 2, 0, 7);       // left strip
    panel(1.4, 3, 5.9, 1.6, -1.5, -Math.PI / 2, 0, 3.2);  // right fill
    panel(3, 1.6, 1.5, 2.4, -5.9, 0, 0, 2.2);              // back kicker
    var pm = new THREE.PMREMGenerator(renderer);
    var tex = pm.fromScene(s, 0.03).texture;
    pm.dispose();
    return tex;
  }

  function roundedRectPath(hw, hd, r, y, n) {
    var pts = [];
    var cs = [[hw - r, hd - r, 0], [-(hw - r), hd - r, Math.PI / 2], [-(hw - r), -(hd - r), Math.PI], [hw - r, -(hd - r), Math.PI * 1.5]];
    cs.forEach(function (c) { for (var i = 0; i <= n; i++) { var a = c[2] + (i / n) * Math.PI / 2; pts.push(new V3(c[0] + Math.cos(a) * r, y, c[1] + Math.sin(a) * r)); } });
    return new THREE.CatmullRomCurve3(pts, true, 'centripetal');
  }

  function sdRB(p, half, r) {
    var qx = Math.abs(p.x) - half.x + r, qy = Math.abs(p.y) - half.y + r, qz = Math.abs(p.z) - half.z + r;
    return Math.hypot(Math.max(qx, 0), Math.max(qy, 0), Math.max(qz, 0)) + Math.min(Math.max(qx, Math.max(qy, qz)), 0) - r;
  }

  function mount(root) {
    var canvas = root.querySelector('canvas'), stage = root.querySelector('.gc-stage');
    var statusEl = root.querySelector('.gc-status'), swatchWrap = root.querySelector('.gc-swatches');
    var btnLight = root.querySelector('.gc-light'), btnShake = root.querySelector('.gc-shake'), btnMotion = root.querySelector('.gc-motion');

    var renderer;
    try { renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: false, powerPreference: 'high-performance' }); }
    catch (e) { stage.insertAdjacentHTML('beforeend', '<p class="gc-fallback">3D preview needs WebGL — try another browser.</p>'); return; }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, navigator.maxTouchPoints > 0 ? 1.5 : 2));
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;

    var scene = new THREE.Scene();
    var BG_DAY = lin('#ece7e1'), BG_NIGHT = lin('#050509');
    scene.background = BG_DAY.clone();
    scene.fog = new THREE.Fog(scene.background, 6, 14);
    scene.environment = makeEnv(renderer);
    scene.environmentRotation.set(0.25, 0.9, 0);

    var camera = new THREE.PerspectiveCamera(28, 1, 0.05, 40);
    camera.position.set(0, 1.55, 3.85);
    camera.lookAt(0, CY - 0.06, 0);

    var hemi = new THREE.HemisphereLight(0xffffff, 0xd9d2c8, 0.55); scene.add(hemi);
    var key = new THREE.DirectionalLight(0xfff4e6, 2.2);
    key.position.set(-1.6, 4.2, 2.2); key.castShadow = true;
    key.shadow.mapSize.set(1024, 1024);
    var sc = key.shadow.camera; sc.left = -1.6; sc.right = 1.6; sc.top = 1.6; sc.bottom = -1.6; sc.near = 1; sc.far = 9;
    key.shadow.radius = 9; key.shadow.blurSamples = 16; key.shadow.bias = -0.0004;
    scene.add(key);
    var glowLight = new THREE.PointLight(0xffffff, 0, 0, 2); scene.add(glowLight);

    var groundMat = new THREE.MeshStandardMaterial({ color: BG_DAY.clone(), roughness: 0.92, metalness: 0 });
    var ground = new THREE.Mesh(new THREE.PlaneGeometry(40, 40), groundMat);
    ground.rotation.x = -Math.PI / 2; ground.receiveShadow = true; scene.add(ground);

    var caseGroup = new THREE.Group(); caseGroup.position.set(0, CY, 0); scene.add(caseGroup);

    var shellGeo = roundedBox(W, H, D, R, 40, 34, 20);
    (function () { var p = shellGeo.attributes.position; for (var i = 0; i < p.count; i++) { var x = p.getX(i) / (W / 2), y = p.getY(i) / (H / 2); var b = Math.max(0, 1 - x * x) * Math.max(0, 1 - y * y); p.setZ(i, p.getZ(i) * (1 + 0.07 * b)); } })();
    function clampY(g, lo, hi) {
      g = g.clone(); var p = g.attributes.position, flat = [];
      for (var i = 0; i < p.count; i++) { var y = p.getY(i), c = THREE.MathUtils.clamp(y, lo, hi); flat[i] = (c !== y) || Math.abs(y - SEAM_Y) < 1e-4; p.setY(i, c); }
      var idx = g.index.array, keep = [];
      for (var j = 0; j < idx.length; j += 3) if (!(flat[idx[j]] && flat[idx[j + 1]] && flat[idx[j + 2]])) keep.push(idx[j], idx[j + 1], idx[j + 2]);
      g.setIndex(keep); return g;
    }
    // plastic body tint only (no glossy reflection layer)
    var tintMat = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, depthWrite: false, blending: THREE.MultiplyBlending, premultipliedAlpha: true });
    var bodyTint = new THREE.Mesh(clampY(shellGeo, -1, SEAM_Y), tintMat); bodyTint.renderOrder = 15; bodyTint.castShadow = true;
    caseGroup.add(bodyTint);
    // lid hinges at the back edge of the seam
    var lid = new THREE.Group(); lid.position.set(0, SEAM_Y, -D / 2); caseGroup.add(lid);
    var lidGeo = clampY(shellGeo, SEAM_Y, 1); lidGeo.translate(0, -SEAM_Y, D / 2);
    var lidTint = new THREE.Mesh(lidGeo, tintMat); lidTint.renderOrder = 15; lidTint.castShadow = true; lid.add(lidTint);

    var half = new V3(W / 2 - WALL, H / 2 - WALL, D / 2 - WALL), rIn = R - WALL;
    var U = {
      uCam: { value: new V3() }, uHalf: { value: half.clone() }, uR: { value: rIn },
      uDown: { value: new V3(0, -1, 0) }, uUp: { value: new V3(0, 1, 0) },
      uFlow: { value: new V3(0.3, 1.7, 4.1) }, uStir: { value: 0.65 }, uTime: { value: 0 },
      uLiquid: { value: new THREE.Color() }, uGlitter: { value: new THREE.Color() }, uGlowCol: { value: new THREE.Color() },
      uGlow: { value: 0 }, uBg: { value: BG_DAY.clone() }, uLevel: { value: -0.02 }, uAmt: { value: 1 },
      uBubble: { value: new V3(0, 0.1, 0) }, uBubbleR: { value: 0 }, uLiquidK: { value: 2.1 },
      uDownL: { value: new V3(0, -1, 0) }, uUpL: { value: new V3(0, 1, 0) }, uBubbleL: { value: new V3(0, 0.4, 0) }, uBubbleRL: { value: 0 },
      uHinge: { value: new V3(0, SEAM_Y, -D / 2) }, uSeam: { value: SEAM_Y }, uAng: { value: 0 }, uSwirl: { value: 0 }, uSwirl2: { value: 0 }, uTw: { value: 0 }, uBMin: { value: new V3() }, uBMax: { value: new V3() }
    };
    var volMat = new THREE.ShaderMaterial({
      uniforms: U, vertexShader: VOL_VERT, fragmentShader: VOL_FRAG, side: THREE.BackSide, transparent: true, depthWrite: false,
      blending: THREE.CustomBlending, blendEquation: THREE.AddEquation, blendSrc: THREE.OneFactor, blendDst: THREE.OneMinusSrcAlphaFactor,
      blendSrcAlpha: THREE.OneFactor, blendDstAlpha: THREE.OneMinusSrcAlphaFactor
    });
    // one bounding box big enough for the body plus the lid at any hinge angle
    var VB_MIN = new V3(-half.x, -half.y, -D / 2 - 0.56), VB_MAX = new V3(half.x, SEAM_Y + 0.64, half.z);
    var volGeo = new THREE.BoxGeometry(VB_MAX.x - VB_MIN.x, VB_MAX.y - VB_MIN.y, VB_MAX.z - VB_MIN.z);
    volGeo.translate((VB_MIN.x + VB_MAX.x) / 2, (VB_MIN.y + VB_MAX.y) / 2, (VB_MIN.z + VB_MAX.z) / 2);
    var volume = new THREE.Mesh(volGeo, volMat); volume.renderOrder = 10; volume.frustumCulled = false; caseGroup.add(volume);

    // white inner insert (only visible when the lid is open)
    function rrShape(hw, hd, r) {
      var sh = new THREE.Shape(); sh.moveTo(-hw + r, -hd); sh.lineTo(hw - r, -hd); sh.quadraticCurveTo(hw, -hd, hw, -hd + r); sh.lineTo(hw, hd - r);
      sh.quadraticCurveTo(hw, hd, hw - r, hd); sh.lineTo(-hw + r, hd); sh.quadraticCurveTo(-hw, hd, -hw, hd - r); sh.lineTo(-hw, -hd + r); sh.quadraticCurveTo(-hw, -hd, -hw + r, -hd); return sh;
    }
    var insertMat = new THREE.MeshStandardMaterial({ color: 0xe2e2df, roughness: 0.55, transparent: true });
    var capGeo = new THREE.ShapeGeometry(rrShape(W / 2 - 0.035, D / 2 - 0.035, R - 0.035), 24);
    var bodyCap = new THREE.Mesh(capGeo, insertMat); bodyCap.rotation.x = -Math.PI / 2; bodyCap.position.y = SEAM_Y - 0.003; bodyCap.receiveShadow = true; caseGroup.add(bodyCap);
    var wellMat = new THREE.MeshStandardMaterial({ color: 0x2c2c2e, roughness: 0.6, transparent: true });
    var wells = [-0.25, 0.25].map(function (x) { var m = new THREE.Mesh(new THREE.CircleGeometry(1, 40), wellMat); m.rotation.x = -Math.PI / 2; m.scale.set(0.15, 0.105, 1); m.position.set(x, SEAM_Y - 0.001, 0.0); caseGroup.add(m); return m; });
    var lidCap = new THREE.Mesh(capGeo, insertMat); lidCap.rotation.x = Math.PI / 2; lidCap.position.set(0, 0.003, D / 2); lid.add(lidCap);
    var insides = [bodyCap, lidCap].concat(wells);
    bodyCap.renderOrder = lidCap.renderOrder = 12; wells.forEach(function (m) { m.renderOrder = 13; });

    var chrome = new THREE.MeshPhysicalMaterial({ color: 0xdcdde2, metalness: 1, roughness: 0.16, clearcoat: 0.3 });
    caseGroup.add(new THREE.Mesh(new THREE.TubeGeometry(roundedRectPath(W / 2 - 0.001, D / 2 - 0.001, R, SEAM_Y, 20), 300, 0.0065, 8, true), chrome));
    caseGroup.add(new THREE.Mesh(new THREE.TubeGeometry(roundedRectPath(W / 2 - 0.003, D / 2 - 0.003, R, SEAM_Y - 0.012, 20), 300, 0.004, 6, true),
      new THREE.MeshStandardMaterial({ color: 0x111114, roughness: 0.6, transparent: true, opacity: 0.35 })));

    var portMat = new THREE.MeshStandardMaterial({ color: 0x222222, roughness: 0.4, emissive: 0x000000 });
    var port = new THREE.Mesh(new THREE.CapsuleGeometry(0.026, 0.07, 6, 16), portMat);
    port.rotation.z = Math.PI / 2; port.scale.set(1, 1, 0.8); port.position.set(0, -H / 2 + 0.012, 0); caseGroup.add(port);

    // ---- post: HDR target + bloom ----
    var rtOpt = { type: THREE.HalfFloatType };
    var rtScene = new THREE.WebGLRenderTarget(4, 4, { type: THREE.HalfFloatType, samples: 4 });
    var rtA = new THREE.WebGLRenderTarget(4, 4, rtOpt), rtB = new THREE.WebGLRenderTarget(4, 4, rtOpt);
    var rtC = new THREE.WebGLRenderTarget(4, 4, rtOpt), rtD = new THREE.WebGLRenderTarget(4, 4, rtOpt);
    var quadCam = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    var quad = new THREE.Mesh(new THREE.PlaneGeometry(2, 2));
    var quadScene = new THREE.Scene(); quadScene.add(quad);
    var brightMat = new THREE.ShaderMaterial({ uniforms: { tSrc: { value: null }, uThr: { value: 1 } }, vertexShader: QUAD_VERT, fragmentShader: BRIGHT_FRAG, depthTest: false, depthWrite: false });
    var blurMat = new THREE.ShaderMaterial({ uniforms: { tSrc: { value: null }, uDir: { value: new THREE.Vector2() } }, vertexShader: QUAD_VERT, fragmentShader: BLUR_FRAG, depthTest: false, depthWrite: false });
    var compMat = new THREE.ShaderMaterial({ uniforms: { tScene: { value: rtScene.texture }, tB1: { value: rtA.texture }, tB2: { value: rtC.texture }, uStr: { value: 0 } }, vertexShader: QUAD_VERT, fragmentShader: COMP_FRAG, depthTest: false, depthWrite: false });
    compMat.toneMapped = true;
    function pass(mat, target) { quad.material = mat; renderer.setRenderTarget(target); renderer.render(quadScene, quadCam); }
    function blur(src, tmp, w, h) {
      blurMat.uniforms.tSrc.value = src.texture; blurMat.uniforms.uDir.value.set(1 / w, 0); pass(blurMat, tmp);
      blurMat.uniforms.tSrc.value = tmp.texture; blurMat.uniforms.uDir.value.set(0, 1 / h); pass(blurMat, src);
    }
    var bloomStr = 0, bloomThr = 1, bw = 4, bh = 4;
    function renderFrame() {
      renderer.setRenderTarget(rtScene); renderer.render(scene, camera);
      if (bloomStr > 0.01) {
        brightMat.uniforms.tSrc.value = rtScene.texture; brightMat.uniforms.uThr.value = bloomThr; pass(brightMat, rtA);
        blur(rtA, rtB, bw, bh); blur(rtA, rtB, bw, bh);
        blurMat.uniforms.tSrc.value = rtA.texture; blurMat.uniforms.uDir.value.set(1 / bw, 0); pass(blurMat, rtD);
        blurMat.uniforms.tSrc.value = rtD.texture; blurMat.uniforms.uDir.value.set(0, 1 / bh); pass(blurMat, rtC);
        blur(rtC, rtD, bw / 2, bh / 2); blur(rtC, rtD, bw / 2, bh / 2); blur(rtC, rtD, bw / 2, bh / 2);
      }
      compMat.uniforms.uStr.value = bloomStr > 0.01 ? bloomStr : 0;
      pass(compMat, null);
    }

    // ---- state ----
    var variantKey = 'blue', glowScale = 1, night = 0, nightTarget = 0;
    var yaw = -0.5, pitch = 0.1, yawV = 0, pitchV = 0;
    var offset = new V3(), offsetV = new V3();
    var caseQuat = new THREE.Quaternion(), prevQuat = new THREE.Quaternion();
    var prevPos = new V3(0, CY, 0), prevVel = new V3();
    var down = new V3(0, -1, 0), downV = new V3(), bubble = new V3(0, 0.4, 0), bubbleV = new V3(), flowV = new V3();
    var stir = 0.65, lastInteract = -10, shakeT = -1, worldG = new V3(0, -1, 0), motionOn = false, gSign = 0;
    var swirlA = 0, swirlV = 0, swirlB = 0, swirlBV = 0, twA = 0;
    var openT = 0, openA = 0, openV = 0, lidBubble = new V3(0, 0.4, 0), lidBubbleV = new V3();
    var btnOpen = root.querySelector('.gc-open'), XAX = new V3(1, 0, 0);
    var clock = new THREE.Clock();

    function updateStatus() { if (statusEl) statusEl.textContent = VARIANTS[variantKey].label + ' · ' + (openT ? 'Open' : 'Closed') + ' · ' + (nightTarget ? 'Lights off — glowing' : 'Daylight'); }
    function setVariant(k) {
      variantKey = k; var v = VARIANTS[k];
      U.uLiquid.value.set(v.liquid); U.uGlitter.value.set(v.glitter);
      var gc = new THREE.Color(v.glow), lum = 0.2126 * gc.r + 0.7152 * gc.g + 0.0722 * gc.b;
      glowScale = 0.2 / Math.max(lum, 0.05);
      U.uGlowCol.value.copy(gc).multiplyScalar(glowScale);
      U.uAmt.value = v.amt; tintMat.color.set(v.shell); glowLight.color.set(v.glow);
      if (swatchWrap) swatchWrap.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.k === k)); });
      stir = Math.max(stir, 0.55); updateStatus();
    }
    if (swatchWrap) {
      swatchWrap.innerHTML = '';
      Object.keys(VARIANTS).forEach(function (k) {
        var v = VARIANTS[k], b = document.createElement('button');
        b.type = 'button'; b.className = 'gc-swatch'; b.dataset.k = k; b.style.setProperty('--swatch', v.swatch);
        b.innerHTML = '<i></i>' + v.label; b.addEventListener('click', function () { setVariant(k); });
        swatchWrap.appendChild(b);
      });
    }
    if (btnLight) btnLight.addEventListener('click', function () {
      nightTarget = nightTarget ? 0 : 1;
      btnLight.setAttribute('aria-pressed', String(!!nightTarget));
      btnLight.textContent = nightTarget ? 'Lights on' : 'Lights off';
      stage.classList.toggle('night', !!nightTarget); updateStatus();
    });
    if (btnShake) btnShake.addEventListener('click', function () { shakeT = 0; lastInteract = clock.elapsedTime; });
    function toggleOpen() {
      openT = openT ? 0 : 1; stir = Math.min(1, stir + 0.12); flowV.y += 0.25;
      if (btnOpen) { btnOpen.setAttribute('aria-pressed', String(!!openT)); btnOpen.textContent = openT ? 'Close the case' : 'Open the case'; }
      lastInteract = clock.elapsedTime; updateStatus();
    }
    if (btnOpen) btnOpen.addEventListener('click', toggleOpen);

    // pointer: drag to rotate, flick to shake
    var dragging = false, lx = 0, ly = 0, lt = 0, sx = 0, sy = 0, st = 0;
    canvas.addEventListener('pointerdown', function (e) { dragging = true; lx = sx = e.clientX; ly = sy = e.clientY; lt = st = performance.now(); canvas.setPointerCapture(e.pointerId); lastInteract = clock.elapsedTime; });
    canvas.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var now = performance.now(), dtp = Math.max((now - lt) / 1000, 1 / 240), dx = e.clientX - lx, dy = e.clientY - ly;
      lx = e.clientX; ly = e.clientY; lt = now;
      var s = 4.2 / canvas.clientWidth;
      yaw += dx * s; pitch = THREE.MathUtils.clamp(pitch + dy * s, -1.25, 1.25);
      yawV = THREE.MathUtils.lerp(yawV, (dx * s) / dtp, 0.5); pitchV = THREE.MathUtils.lerp(pitchV, (dy * s) / dtp, 0.5);
      if (Math.hypot(dx, dy) / dtp > 900) offsetV.add(new V3(dx, -dy, 0).multiplyScalar(0.0035));
      lastInteract = clock.elapsedTime;
    });
    canvas.addEventListener('pointerup', function (e) {
      if (dragging && Math.hypot(e.clientX - sx, e.clientY - sy) < 8 && performance.now() - st < 350) { yawV = 0; pitchV = 0; toggleOpen(); }
      dragging = false;
    });
    canvas.addEventListener('pointercancel', function () { dragging = false; });
    canvas.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') yawV -= 2.5; else if (e.key === 'ArrowRight') yawV += 2.5;
      else if (e.key === 'ArrowUp') pitchV -= 2; else if (e.key === 'ArrowDown') pitchV += 2;
      else if (e.key === 'Enter' || e.key === ' ') shakeT = 0; else if (e.key === 'o' || e.key === 'O') toggleOpen(); else return;
      e.preventDefault(); lastInteract = clock.elapsedTime;
    });

    // phone motion: tilt pours the liquid, shake jolts it
    var lpG = new V3(0, -9.8, 0), phoneJolt = new V3();
    function onMotion(e) {
      var g = e.accelerationIncludingGravity;
      if (g && g.x != null) {
        if (!gSign && Math.abs(g.y) > 4) gSign = g.y > 0 ? -1 : 1;
        if (gSign) { var v = new V3(g.x * gSign, g.y * gSign, g.z * gSign); if (v.lengthSq() > 1) { v.normalize().applyQuaternion(camera.quaternion); worldG.lerp(v, 0.25).normalize(); } }
      }
      var a = e.acceleration, lx3, ly3, lz3;
      if (a && a.x != null) { lx3 = a.x; ly3 = a.y; lz3 = a.z; }
      else if (g && g.x != null) { lpG.lerp(new V3(g.x, g.y, g.z), 0.1); lx3 = g.x - lpG.x; ly3 = g.y - lpG.y; lz3 = g.z - lpG.z; }
      if (lx3 != null) {
        var m = Math.hypot(lx3, ly3, lz3);
        if (m > 1.2) {
          var jolt = new V3(lx3, ly3, lz3).clampLength(0, 30).applyQuaternion(camera.quaternion);
          if (jolt.length() > phoneJolt.length()) phoneJolt.copy(jolt); else phoneJolt.lerp(jolt, 0.5);
          lastInteract = clock.elapsedTime;
        }
      }
    }
    var hasMotion = typeof window.DeviceMotionEvent !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
    function setMotion(on) {
      motionOn = on;
      if (on) { gSign = 0; window.addEventListener('devicemotion', onMotion); } else { window.removeEventListener('devicemotion', onMotion); worldG.set(0, -1, 0); }
      if (btnMotion) { btnMotion.hidden = false; btnMotion.textContent = on ? 'Phone shake on' : 'Phone shake off'; btnMotion.setAttribute('aria-pressed', String(on)); }
    }
    if (hasMotion) {
      if (typeof DeviceMotionEvent.requestPermission === 'function') {
        // iPhone: Safari only allows motion after a tap, so ask on the visitor's first tap anywhere in the viewer
        var ask = function () {
          root.removeEventListener('click', ask, true); root.removeEventListener('touchend', ask, true);
          DeviceMotionEvent.requestPermission().then(function (r) { if (r === 'granted') setMotion(true); }).catch(function () {});
        };
        root.addEventListener('click', ask, true); root.addEventListener('touchend', ask, true);
        if (btnMotion) { btnMotion.hidden = false; btnMotion.textContent = 'Enable phone shake'; }
      } else setMotion(true);
      if (btnMotion) btnMotion.addEventListener('click', function () { if (motionOn) setMotion(false); else if (typeof DeviceMotionEvent.requestPermission !== 'function') setMotion(true); else DeviceMotionEvent.requestPermission().then(function (r) { if (r === 'granted') setMotion(true); }).catch(function () {}); });
    }

    var invQ = new THREE.Quaternion();

    function resize() {
      var w = stage.clientWidth, h = stage.clientHeight; if (!w || !h) return;
      var pr = renderer.getPixelRatio();
      renderer.setSize(w, h, false);
      rtScene.setSize(w * pr, h * pr);
      bw = Math.max(4, Math.round(w * pr / 4)); bh = Math.max(4, Math.round(h * pr / 4));
      rtA.setSize(bw, bh); rtB.setSize(bw, bh); rtC.setSize(bw / 2, bh / 2); rtD.setSize(bw / 2, bh / 2);
      camera.aspect = w / h; camera.fov = w / h < 0.95 ? 33 : 28; camera.updateProjectionMatrix();
    }
    new ResizeObserver(resize).observe(stage);
    var visible = true, running = false;
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) loop(); }).observe(stage);

    var col = new THREE.Color(), ex = new THREE.Euler(0, 0, 0, 'YXZ');
    function update(dt, t) {
      night += (nightTarget - night) * (1 - Math.exp(-dt * 3.2));
      col.copy(BG_DAY).lerp(BG_NIGHT, night);
      scene.background.copy(col); scene.fog.color.copy(col); groundMat.color.copy(col); U.uBg.value.copy(col);
      U.uGlow.value = night;
      hemi.intensity = 0.55 * (1 - night) + 0.015; key.intensity = 2.2 * (1 - night) + 0.02;
      scene.environmentIntensity = 1 - night * 0.975;
      glowLight.intensity = night * 4 * glowScale;
      var vv = VARIANTS[variantKey];
      portMat.emissive.set(vv.glow).multiplyScalar(night * 1.2 * glowScale);
      portMat.color.set(night > 0.5 ? 0x111111 : 0x2a2a2a);
      bloomStr = night * 1.35; bloomThr = 1.0 - night * 0.65;

      if (!dragging) {
        yaw += yawV * dt; pitch += pitchV * dt;
        yawV *= Math.exp(-dt * 2.4); pitchV *= Math.exp(-dt * 2.4);
        if (pitch > 1.25 || pitch < -1.25) { pitch = THREE.MathUtils.clamp(pitch, -1.25, 1.25); pitchV *= -0.3; }
        if (t - lastInteract > 3.5) { var k = Math.min(1, (t - lastInteract - 3.5) / 2); yaw += Math.cos(t * 0.35) * 0.16 * dt * k; pitch += (0.1 - pitch) * dt * 0.6 * k; }
      }
      if (shakeT >= 0) {
        shakeT += dt;
        var f = Math.sin(shakeT * Math.PI * 2 * 4.2) * Math.exp(-shakeT * 1.6);
        offsetV.x += f * 42 * dt; offsetV.y += Math.sin(shakeT * 29) * 9 * dt * Math.exp(-shakeT * 2);
        yawV += f * 6 * dt; stir = Math.min(1, stir + 3 * dt);
        var env = Math.exp(-shakeT * 1.2);
        flowV.x += f * 38 * dt; flowV.y += Math.cos(shakeT * 21) * 26 * dt * env; flowV.z += Math.sin(shakeT * 17) * 16 * dt * env;
        swirlV += 9 * dt * env * (shakeT < 0.9 ? 1 : 0.3); swirlBV += f * 14 * dt;
        if (shakeT > 1.6) shakeT = -1;
      }
      offsetV.addScaledVector(offset, -dt * 140); offsetV.multiplyScalar(Math.exp(-dt * 7));
      offset.addScaledVector(offsetV, dt); offset.clampLength(0, 0.2);
      caseGroup.position.set(offset.x, CY + offset.y, offset.z);
      ex.set(pitch, yaw, Math.sin(t * 0.6) * 0.012 + offset.x * 0.4);
      caseQuat.setFromEuler(ex); caseGroup.quaternion.copy(caseQuat);

      // container kinematics drive the liquid
      var vel = caseGroup.position.clone().sub(prevPos).divideScalar(dt), acc = vel.clone().sub(prevVel).divideScalar(dt);
      prevPos.copy(caseGroup.position); prevVel.copy(vel);
      var dq = caseQuat.clone().multiply(prevQuat.clone().invert()); prevQuat.copy(caseQuat);
      var angW = 2 * Math.acos(THREE.MathUtils.clamp(Math.abs(dq.w), -1, 1)) / dt, axis = new V3(dq.x, dq.y, dq.z);
      if (axis.lengthSq() > 1e-10) axis.normalize().multiplyScalar(dq.w < 0 ? -angW : angW); else axis.set(0, 0, 0);
      invQ.copy(caseQuat).invert();
      var angL = axis.applyQuaternion(invQ), accL = acc.clone().clampLength(0, 60).applyQuaternion(invQ);
      var effG = worldG.clone().multiplyScalar(9).sub(acc.clone().clampLength(0, 40).multiplyScalar(0.12)).normalize().applyQuaternion(invQ);
      downV.addScaledVector(effG.sub(down), dt * 26).multiplyScalar(Math.exp(-dt * 4.5));
      down.addScaledVector(downV, dt).normalize();
      flowV.addScaledVector(angL, -dt * 0.9).addScaledVector(accL, -dt * 0.035); flowV.multiplyScalar(Math.exp(-dt * 1.4));
      U.uFlow.value.addScaledVector(flowV, dt).addScaledVector(down, dt * 0.018 * stir);
      stir = Math.min(1, stir + (angL.length() * 0.035 + accL.length() * 0.004) * dt);
      stir = 0.3 + (stir - 0.3) * Math.exp(-dt * 0.16);
      swirlV += -angL.y * 0.9 * dt; swirlBV += -angL.z * 0.9 * dt;
      swirlV *= Math.exp(-dt * 0.7); swirlBV *= Math.exp(-dt * 1.4);
      swirlA += swirlV * dt; swirlB += swirlBV * dt;
      swirlA = THREE.MathUtils.clamp(swirlA, -1.5, 1.5) * Math.exp(-dt * 0.45);
      swirlB = THREE.MathUtils.clamp(swirlB, -1.0, 1.0) * Math.exp(-dt * 0.6);
      twA += dt * (1.6 + Math.min(18, flowV.length() * 6 + Math.abs(swirlV) * 2.5));
      // physical phone shake: churn the liquid + flakes like the Shake button
      var pm = phoneJolt.length();
      if (pm > 0.05) {
        var jl = phoneJolt.clone().applyQuaternion(invQ);
        flowV.addScaledVector(jl, -1.9 * dt);
        swirlV += pm * 1.3 * dt * (swirlV < 0 ? -1 : 1); swirlBV += jl.x * 1.3 * dt;
        stir = Math.min(1, stir + pm * 0.12 * dt);
        offsetV.addScaledVector(phoneJolt, -0.35 * dt);
        twA += dt * Math.min(12, pm * 0.6);
      }
      phoneJolt.multiplyScalar(Math.exp(-dt * 6));
      U.uSwirl.value = swirlA; U.uSwirl2.value = swirlB; U.uTw.value = twA;

      // lid: springy hinge with a little overshoot
      openV += (openT * 1.9 - openA) * dt * 110; openV *= Math.exp(-dt * 10); openA += openV * dt;
      lid.rotation.x = -openA;
      var showIn = openA > 0.03; insides.forEach(function (m) { m.visible = showIn; });

      // per-half liquid frames (the lid frame is rotated by the hinge)
      var upW = new V3(0, 1, 0).applyQuaternion(invQ);
      var downLid = down.clone().applyAxisAngle(XAX, openA), upLid = upW.clone().applyAxisAngle(XAX, openA);
      function support(up, lo, hi) {
        var br0 = 0.062, bH = half.clone().subScalar(br0), br = Math.max(rIn - br0, 0);
        var v = new V3(Math.tanh(up.x * 25) * (bH.x - br) + up.x * br, Math.tanh(up.y * 25) * (bH.y - br) + up.y * br, Math.tanh(up.z * 25) * (bH.z - br) + up.z * br);
        v.y = THREE.MathUtils.clamp(v.y, lo, hi); return v;
      }
      // air bubbles float to the highest point of each half
      bubbleV.addScaledVector(support(down.clone().negate(), -H, SEAM_Y - 0.062).sub(bubble), dt * 30).multiplyScalar(Math.exp(-dt * 6)); bubble.addScaledVector(bubbleV, dt);
      lidBubbleV.addScaledVector(support(downLid.clone().negate(), SEAM_Y + 0.062, H).sub(lidBubble), dt * 30).multiplyScalar(Math.exp(-dt * 6)); lidBubble.addScaledVector(lidBubbleV, dt);
      U.uBubble.value.copy(bubble); U.uBubbleR.value = 0;
      U.uBubbleL.value.copy(lidBubble);
      U.uDown.value.copy(down); U.uUp.value.copy(upW);
      U.uDownL.value.copy(downLid); U.uUpL.value.copy(upLid);
      U.uAng.value = openA;
      // tight march bounds: body box + rotated lid corners
      var bmin = new V3(-half.x, -half.y, -half.z), bmax = new V3(half.x, SEAM_Y, half.z), cr = new V3(), hg = U.uHinge.value;
      [-half.x, half.x].forEach(function (x) { [SEAM_Y, half.y].forEach(function (y) { [-half.z, half.z].forEach(function (z) {
        cr.set(x, y, z).sub(hg).applyAxisAngle(XAX, -openA).add(hg); bmin.min(cr); bmax.max(cr);
      }); }); });
      U.uBMin.value.copy(bmin).subScalar(0.01); U.uBMax.value.copy(bmax).addScalar(0.01);
      U.uStir.value = stir; U.uTime.value = t;
      glowLight.position.copy(caseGroup.position).add(new V3(0, -0.15, 0.1));
      caseGroup.updateMatrixWorld(true);
      U.uCam.value.copy(camera.position).applyMatrix4(new THREE.Matrix4().copy(volume.matrixWorld).invert());
    }
    function loop() {
      if (running) return; running = true;
      var tick = function () {
        if (!visible) { running = false; return; }
        var dt = THREE.MathUtils.clamp(clock.getDelta(), 1 / 240, 1 / 30);
        update(dt, clock.elapsedTime); renderFrame(); requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }

    setVariant('blue');
    caseQuat.setFromEuler(ex.set(pitch, yaw, 0)); prevQuat.copy(caseQuat); caseGroup.quaternion.copy(caseQuat);
    resize(); loop();
    root.__gc = { toggleOpen: toggleOpen, setVariant: setVariant, setNight: function (n) { nightTarget = n; night = n; stage.classList.toggle('night', !!n); updateStatus(); }, state: function () { return { stir: stir, down: down.toArray() }; } };
  }

  document.querySelectorAll('section.gc').forEach(function (sec) {
    if (sec.__gcMounted) return; sec.__gcMounted = true;
    sec.innerHTML = MARKUP;
    var st = document.createElement('style'); st.textContent = CSS; sec.prepend(st);
    mount(sec);
  });
}

function boot() {
  // load three.js through a module script (Shopify's asset minifier rewrites import())
  window.__gcRun = function (T) { try { run(T); } catch (e) { console.error('GlowyCase 3D error', e); } };
  var m = document.createElement('script');
  m.type = 'module';
  m.textContent = 'import * as T from "' + THREE_URL + '"; window.__gcRun(T);';
  document.head.appendChild(m);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
